import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M30 80q0-30 70-30t70 30v60q-70 40-140 0Z" }, null, -1),
    _createElementVNode("path", {
      fill: "var(--mc-avatar)",
      d: "M50 92h36v6H50zM114 92h36v6h-36zM96 102q-6 28 4 54 10-26 4-54Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "var(--mc-avatar)",
      "stroke-linecap": "round",
      "stroke-width": "5",
      d: "M60 142q40 14 80 0"
    }, null, -1)
  ]))]))
}
export default { render: render }